<template>
  <v-card-text>
    <v-divider class="mb-2"></v-divider>
    <v-row>

      <v-col cols="3">
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title class="font-weight-medium">Preparer Name</v-list-item-title>
            <v-list-item-subtitle>{{ contact.name }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-col>

      <v-col cols="3">
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title class="font-weight-medium">Firm Name</v-list-item-title>
            <v-list-item-subtitle>{{ prospectPacket.taxPreparer.firmName }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-col>

      <v-col cols="3">
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title class="font-weight-medium">Street Address</v-list-item-title>
            <v-list-item-subtitle>{{ contact.address1 }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-col>

      <v-col cols="3">
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title class="font-weight-medium">City</v-list-item-title>
            <v-list-item-subtitle>{{ contact.city }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-col>

      <v-col cols="3">
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title class="font-weight-medium">State</v-list-item-title>
            <v-list-item-subtitle>{{ contact.state }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-col>

      <v-col cols="3">
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title class="font-weight-medium">Postal Code</v-list-item-title>
            <v-list-item-subtitle>{{ contact.zip }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-col>

      <v-col cols="3">
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title class="font-weight-medium">Phone Number</v-list-item-title>
            <v-list-item-subtitle>{{ contact.phone }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-col>

      <v-col cols="3">
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title class="font-weight-medium">Email</v-list-item-title>
            <v-list-item-subtitle>{{ contact.email }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-col>

    </v-row>
  </v-card-text>
</template>

<script>
export default {
  name: 'TaxPreparerInformation',
  data: () => ({
    temp: null,
  }),
  computed: {
    prospectPacket() {
      return this.$store.state.prospectPacket;
    },
    contactType() {
      return this.$store.state.prospectPacket.taxPreparer.contactType;
    },
    contact() {
      return this.$store.state.prospectPacket.contacts.find((x) => x.contactType === this.contactType);
    },
  },
};
</script>

<style lang="scss" scoped>
.v-list-item__title, .v-list-item__subtitle {
  white-space: unset !important;
}
.col-xl, .col-xl-auto, .col-xl-12, .col-xl-11, .col-xl-10, .col-xl-9, .col-xl-8,
.col-xl-7, .col-xl-6, .col-xl-5, .col-xl-4, .col-xl-3, .col-xl-2, .col-xl-1, .col-lg,
.col-lg-auto, .col-lg-12, .col-lg-11, .col-lg-10, .col-lg-9, .col-lg-8, .col-lg-7,
.col-lg-6, .col-lg-5, .col-lg-4, .col-lg-3, .col-lg-2, .col-lg-1, .col-md, .col-md-auto,
.col-md-12, .col-md-11, .col-md-10, .col-md-9, .col-md-8, .col-md-7, .col-md-6, .col-md-5,
.col-md-4, .col-md-3, .col-md-2, .col-md-1, .col-sm, .col-sm-auto, .col-sm-12, .col-sm-11,
.col-sm-10, .col-sm-9, .col-sm-8, .col-sm-7, .col-sm-6, .col-sm-5, .col-sm-4, .col-sm-3,
.col-sm-2, .col-sm-1, .col, .col-auto, .col-12, .col-11, .col-10, .col-9, .col-8, .col-7,
.col-6, .col-5, .col-4, .col-3, .col-2, .col-1 {
  padding: unset !important;
}
</style>
